<template>
  <div>
    <b-container>
      <b-row>
        <b-col>
          <h1 class="h1">Pastor Jerry Dean</h1>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <img src="../assets/Jerry.jpg" />
      <b-row>
        <p>Jerry has been in the ministry for over 30 years. He was raised on a small farm in northern Illinois along with two older brothers. He was blessed to have two godly parents who were excellent examples of Christ. He accepted Christ at an early age and as a young person became involved with his parents and the church in ministering to others in a number of ways.</p>
      </b-row>
      <b-row>
        <p>Jerry met and then married his wife, Vicki, at Oakhill Christian Church in Janesville, where he ministered for 20 years. God has blessed them with 4 children and 30+ years of marriage. Two of his other passions are sports and music. He played 2 different college sports, has won numerous powerlifting titles, and coached a number of championship teams, both guys and girls, at the high school and college levels. This experience gives him a unique perspective in encouraging and motivating others in their walk with God, and has opened doors to share the gospel with many athletes. Jerry was also very blessed to have grown up near a grandmother who was a gifted professional musician. She passed on her love of music and praise to him. He has written numerous songs, several of which have been recorded by local artists.</p>
      </b-row>
      <b-row>
        <p>Jerry is also became an author with the release of his book, Joshua... Learn to Lead and Succeed. This study in the Biblical book of Joshua inspires and challenges you to "Think and Pray over 24 Strategies for True Success."</p>
      </b-row>
      <b-row>
        <p>Jerry is very thankful and grateful to God for His many blessings and goodness. We do serve an amazing God.</p>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
export default {
  metaInfo:{
    title: 'Faith Christian Church Evansville: About Jerry Dean Pastor',
    description: 'Learn more about our pastor Jerry Dean',
    htmlAttrs: {
      lang: 'en',
      amp: true
    }
  },
};
</script>

<style lang="scss" scoped>
img {
  float: left;
  margin: 20px;
}
</style>